import { http } from '../../http/client';
import type { Summernote } from './summernote';

export function create(blob: Blob): Promise<Summernote> {
  const data = new FormData();
  data.append('summernote[image]', blob);
  return http.post<Summernote>('/api/v1/summernotes', { body: data });
}
